import { StrictMode } from 'react'
import { render } from 'react-dom'
import App from 'App'

// Normalizza eventuali hash #/qualcosa in URL "pulita"
(function normalizeHashForBrowserRouter() {
    const { hash, pathname, search } = window.location;

    if (hash.startsWith("#/")) {
        // Ottieni il percorso senza #
        const cleanPath = hash.slice(1); // rimuove solo #
        const queryFromHash = cleanPath.includes("?") ? "?" + cleanPath.split("?")[1] : "";
        const pathFromHash = cleanPath.split("?")[0];
        // Rimuove eventuali doppi slash
        const normalizedPath = `${pathname}${pathFromHash}${queryFromHash}`.replace(/\/{2,}/g, "/");
        // Riscrivi URL nel browser senza ricaricare la pagina
        window.history.replaceState(
            null,
            "",
            normalizedPath
        );
    }
})();

render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root')
)



/** import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
*/
